module.exports = "<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode === 'edit'\">\n    <ui-select multiple tagging tagging-label=\"false\" ng-model=\"$ctrl.ngModel\" theme=\"bootstrap\" sortable=\"true\">\n        <ui-select-match placeholder=\"Type to add more tanks\">{{$item}}</ui-select-match>\n        <ui-select-choices repeat=\"dummy in []\">{{dummy}}</ui-select-choices>\n    </ui-select>\n</div>\n<div>\n\n<div ng-if=\"$ctrl.mode === 'view'\">\n    <span ng-repeat=\"t in $ctrl.ngModel\">{{t}}{{{true: '', false: ', '}[$last]}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/tanks.picker.html
// module id = 731
// module chunks = 0